import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import RoofSeals from "@/pages/RoofSeals";

export const Route = createFileRoute("/rv-how-to-check-your-roof-seals-1")({
  head: () => pageHead({
    title: 'How to Check Your RV Roof Seals',
    description: 'Step-by-step guide to inspecting and maintaining RV roof seals — prevent leaks with tips from the Rex & Sons RVs service team.',
    path: '/rv-how-to-check-your-roof-seals-1',
  }),
  component: RoofSeals,
});
